import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const API =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";

const LectorQrPresente = ({
  etapa_id,
  dependencia,
  onPresenteMarcado,
  onClose,
}) => {
  const [mensaje, setMensaje] = useState("");
  const [dniManual, setDniManual] = useState("");

  const Usuario = ObtieneDatosCookies();

  const scannerRef = useRef(null);
  const yaEscaneado = useRef(false);

  // =========================
  // STOP SCANNER SAFE
  // =========================
  const detenerScanner = async () => {
    try {
      if (scannerRef.current) {
        const state =
          scannerRef.current.getState?.();

        if (state === 2) {
          await scannerRef.current.stop();
        }

        scannerRef.current.clear();
        scannerRef.current = null;
      }
    } catch (err) {
      console.warn(
        "Error cerrando scanner",
        err
      );
    }
  };

  // =========================
  // MARCAR PRESENTE
  // =========================
  const marcarPresente = async (dni) => {
    try {
      const dniLimpio = String(
        dni || ""
      )
        .replace(/\./g, "")
        .trim();

      if (!dniLimpio) {
        Swal.fire({
          icon: "warning",
          title: "DNI inválido",
          text:
            "No se pudo determinar el DNI",
        });

        yaEscaneado.current = false;
        return;
      }

      if (!dependencia) {
        Swal.fire({
          icon: "warning",
          title:
            "Dependencia no definida",
          text:
            "No se pudo determinar qué dependencia está registrando el presente",
        });

        yaEscaneado.current = false;
        return;
      }

      const res = await axios.post(
        `${API}/marcarPresenteEtapa`,
        {
          dni: dniLimpio,

          proceso_etapa_id:
            etapa_id,

          usuario: `${Usuario?.identificacion || ""} ( ${
            Usuario?.apellido || ""
          } )`,

          dependencia,
        }
      );

      // =====================================================
      // ACTUALIZACIÓN LOCAL INMEDIATA
      // =====================================================
      // El backend ya nos devuelve el registro recién creado.
      // Se lo entregamos al componente padre para que pinte
      // la asistencia sin volver a consultar listarPresentesEtapa.
      const registroCreado = {
        ...(res.data || {}),
        dni:
          res.data?.dni ||
          dniLimpio,
        proceso_etapa_id:
          res.data?.proceso_etapa_id ||
          etapa_id,
        dependencia:
          res.data?.dependencia ||
          dependencia,
      };

      onPresenteMarcado?.(
        registroCreado
      );

      Swal.fire({
        icon: "success",
        title: "Presente marcado",
        html: `
          <div>
            DNI:
            <b>${registroCreado.dni}</b>
          </div>

          <div style="margin-top:8px;">
            Dependencia:
            <b>${registroCreado.dependencia}</b>
          </div>
        `,
        timer: 2000,
        showConfirmButton: false,
      });

      setMensaje(
        `OK: ${registroCreado.dni} - ${registroCreado.dependencia}`
      );

      setTimeout(async () => {
        await detenerScanner();

        onClose?.(true);
      }, 800);
    } catch (err) {
      console.error(
        "Error marcando presente:",
        err
      );

      const msg =
        err?.response?.status === 409
          ? `El postulante ya fue marcado como presente hoy por ${dependencia}`
          : err?.response?.data?.error ||
            err?.response?.data?.message ||
            "Error al marcar presente";

      Swal.fire({
        icon: "error",
        title:
          "No se pudo marcar",
        text: msg,
      });

      setMensaje(msg);

      setTimeout(() => {
        yaEscaneado.current = false;
      }, 2000);
    }
  };

  // =========================
  // QR SCANNER
  // =========================
  useEffect(() => {
    if (!etapa_id) return;

    const scanner =
      new Html5Qrcode("qr-reader");

    scannerRef.current = scanner;

    const iniciar = async () => {
      try {
        await scanner.start(
          {
            facingMode:
              "environment",
          },
          {
            fps: 10,
            qrbox: 250,
          },
          async (
            decodedText
          ) => {
            if (
              yaEscaneado.current
            ) {
              return;
            }

            yaEscaneado.current =
              true;

            const dni =
              decodedText.trim();

            await marcarPresente(
              dni
            );
          }
        );
      } catch (err) {
        console.error(
          "Error iniciando cámara",
          err
        );

        Swal.fire({
          icon: "error",
          title:
            "Error cámara",
          text:
            "No se pudo acceder a la cámara",
        });
      }
    };

    iniciar();

    return () => {
      detenerScanner();
    };
  }, [etapa_id, dependencia]);

  // =========================
  // DNI MANUAL
  // =========================
  const enviarManual =
    async () => {
      const dniLimpio =
        String(
          dniManual || ""
        )
          .replace(/\./g, "")
          .trim();

      if (!dniLimpio) {
        Swal.fire({
          icon: "warning",
          title:
            "Falta DNI",
          text:
            "Ingresá un DNI",
        });

        return;
      }

      await marcarPresente(
        dniLimpio
      );

      setDniManual("");
    };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "auto",
      }}
    >
      {/* ========================= */}
      {/* DEPENDENCIA */}
      {/* ========================= */}

      <div
        style={{
          marginBottom: 15,
          padding: 10,
          borderRadius: 8,
          background: "#f3f5f7",
        }}
      >
        <small>
          Marcando presente para
        </small>

        <div>
          <strong>
            {dependencia ||
              "Sin dependencia definida"}
          </strong>
        </div>
      </div>

      {/* ========================= */}
      {/* INPUT MANUAL */}
      {/* ========================= */}

      <div
        style={{
          marginBottom: 10,
        }}
      >
        <input
          type="number"
          placeholder="Ingresar DNI manual"
          value={dniManual}
          onChange={(e) =>
            setDniManual(
              e.target.value
            )
          }
          onKeyDown={(e) => {
            if (
              e.key === "Enter"
            ) {
              enviarManual();
            }
          }}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 5,
          }}
        />

        <button
          className="btn btn-success"
          onClick={
            enviarManual
          }
        >
          Dar presente por DNI
        </button>
      </div>

      {/* ========================= */}
      {/* QR */}
      {/* ========================= */}

      <div
        id="qr-reader"
        style={{
          width: "100%",
          borderRadius: 10,
          overflow: "hidden",
        }}
      />

      <p
        style={{
          marginTop: 10,
        }}
      >
        {mensaje}
      </p>

      {/* ========================= */}
      {/* CERRAR */}
      {/* ========================= */}

      <button
        className="btn btn-danger"
        onClick={async () => {
          await detenerScanner();

          onClose?.(false);
        }}
      >
        Cerrar
      </button>
    </div>
  );
};

export default LectorQrPresente;